module.exports = __webpack_public_path__ + "img/img_2.42e09643.jpg";